import { FilterInputDataMap } from './../types';
import { FilterStateMap, FilterType } from '../types';
import moment from 'moment';

type FilterFunctionMap = {
  [K in FilterType]: (state: FilterStateMap[K], data: FilterInputDataMap[K] | null) => boolean
}

const unboundPast = moment(0);
const unboundFuture = moment().add(100, 'years');
const filter: FilterFunctionMap = {
  date: ({to, from}, data) => data && data.isBetween(from || unboundPast, to || unboundFuture) || false,
  input: ({text}, data) => !text || (data && data.toLowerCase().includes(text.toLowerCase())),
  numeric: ({to, from}, data) => data && data >= (from != null ? from: -Infinity) && data <= (to != null ? to:Infinity),
  options: ({options}, data) => options.length === 0 || options.includes(data),
  null: () => false
}

export default filter;